// src/contexts/PreisContext.js
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

export const PreisContext = createContext();

export const PreisProvider = ({ children }) => {
  const [preise, setPreise] = useState([]);
  const [loadingPreise, setLoadingPreise] = useState(true);
  const [errorPreise, setErrorPreise] = useState(null);

  const PREISE_API_URL =
    'https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/Preise?fields=*&limit=500';

  useEffect(() => {
    const ac = new AbortController();
    const fetchPreise = async () => {
      setLoadingPreise(true); setErrorPreise(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(PREISE_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setPreise(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorPreise('Fehler beim Laden der Preise');
      } finally {
        if (!ac.signal.aborted) setLoadingPreise(false);
      }
    };
    fetchPreise();
    /* return () => ac.abort(); */
  }, []);

  return (
    <PreisContext.Provider value={{ preise, loadingPreise, errorPreise }}>
      {children}
    </PreisContext.Provider>
  );
};
